import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import SelectCityDlg from './SelectCityDlg';
import './MainMap.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import axiosInstance, { API_URL, normalise } from '../common/Constants';
import Paper from '@material-ui/core/Paper';
import { BsDot } from 'react-icons/bs';

const styles = (theme) => ({
  root: {
    overflowX: 'hidden',
    overflowY: 'auto',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    // backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7) ),url("./assets/imgs/1.jpg")',
  },

  loginBtnDiv: {
    border: '1px solid #fff',
    width: '170px',
    margin: '0 auto 0.8em',
    padding: theme.spacing(1, 2),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3.5),
    cursor: 'pointer',
  },
});

const drawData = {
  seoul: { firstColor: '#FD7150', secondColor: '#555555', firstPoint: [0, 20], secondPoint: [50, 20], thirdPoint: [75, 75], left: true },
  gygg: { firstColor: '#F0944F', secondColor: '#555555', firstPoint: [0, 20], secondPoint: [50, 20], thirdPoint: [100, 100], left: true },
  incheon: {
    firstColor: '#6CC7A4',
    secondColor: '#555555',
    firstPoint: [0, 20],
    secondPoint: [20, 20],
    thirdPoint: [45, 75],
    left: true,
  },
  gangwon: {
    firstColor: '#E1F520',
    secondColor: '#555555',
    firstPoint: [400, 15],
    secondPoint: [300, 15],
    thirdPoint: [200, 75],
    left: false,
  },
  chungbuk: {
    firstColor: '#3862B5',
    secondColor: '#555555',
    firstPoint: [400, 15],
    secondPoint: [300, 15],
    thirdPoint: [150, 120],
    left: false,
  },
  chungnam: {
    firstColor: '#87C2FD',
    secondColor: '#555555',
    firstPoint: [0, 20],
    secondPoint: [20, 20],
    thirdPoint: [75, 150],
    left: true,
  },
  jeonbuk: {
    firstColor: '#F5DA67',
    secondColor: '#555555',
    firstPoint: [0, 20],
    secondPoint: [20, 20],
    thirdPoint: [80, 220],
    left: true,
  },
  daejeon: {
    firstColor: '#7FF6FF',
    secondColor: '#555555',
    firstPoint: [0, 20],
    secondPoint: [20, 20],
    thirdPoint: [100, 170],
    left: true,
  },
  gwangju: {
    firstColor: '#AAB02A',
    secondColor: '#555555',
    firstPoint: [0, 20],
    secondPoint: [20, 20],
    thirdPoint: [65, 265],
    left: true,
  },
  jeonnam: {
    firstColor: '#CFC06A',
    secondColor: '#555555',
    firstPoint: [0, 20],
    secondPoint: [20, 20],
    thirdPoint: [95, 280],
    left: true,
  },

  gyeongbuk: {
    firstColor: '#F898FF',
    secondColor: '#555555',
    firstPoint: [400, 15],
    secondPoint: [300, 15],
    thirdPoint: [200, 150],
    left: false,
  },
  daegu: {
    firstColor: '#FF739A',
    secondColor: '#555555',
    firstPoint: [400, 15],
    secondPoint: [300, 15],
    thirdPoint: [180, 210],
    left: false,
  },
  gyeongnam: {
    firstColor: '#C890E8',
    secondColor: '#555555',
    firstPoint: [400, 15],
    secondPoint: [300, 15],
    thirdPoint: [180, 250],
    left: false,
  },
  ulsan: {
    firstColor: '#FFD49A',
    secondColor: '#555555',
    firstPoint: [400, 15],
    secondPoint: [300, 15],
    thirdPoint: [220, 230],
    left: false,
  },
  busan: {
    firstColor: '#A65081',
    secondColor: '#555555',
    firstPoint: [400, 15],
    secondPoint: [300, 15],
    thirdPoint: [210, 260],
    left: false,
  },
  jeju: { firstColor: '#CC7160', secondColor: '#555555', firstPoint: [0, 20], secondPoint: [20, 20], thirdPoint: [50, 365], left: true },
  userInfoText: {
    fontWeight: 700,
  },
};

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    // border: `1px solid ${theme.palette.primary.main}`,
  },
  colorPrimary: {
    backgroundColor: '#f3f3f3',
  },
  bar: {
    borderRadius: 0,
    backgroundColor: 'rgb(123, 177, 208)',
  },
}))(LinearProgress);

class MainMap extends Component {
  constructor(props) {
    super(props);
    this.goToPage = this.goToPage.bind(this);
    this.canvas = React.createRef();
    this.state = {
      selectedCity: 'none',
      popup: false,
      list: {
        none: [],
        seoul: [],
        gygg: [],
        incheon: [],
        gangwon: [],
        chungbuk: [],
        chungnam: [],
        daejeon: [],
        jeonbuk: [],
        gwangju: [],
        jeonnam: [],
        gyeongbuk: [],
        daegu: [],
        gyeongnam: [],
        ulsan: [],
        busan: [],
        jeju: [],
      },
    };
  }

  getCodeToName(code) {
    if (code === 'seoul') {
      return '서울특별시';
    } else if (code === 'gygg') {
      return '경기도';
    } else if (code === 'incheon') {
      return '인천광역시';
    } else if (code === 'gangwon') {
      return '강원도';
    } else if (code === 'chungbuk') {
      return '충청북도';
    } else if (code === 'chungnam') {
      return '충청남도';
    } else if (code === 'jeonbuk') {
      return '전라북도';
    } else if (code === 'daejeon') {
      return '대전광역시';
    } else if (code === 'jeonbuk') {
      return '전라북도';
    } else if (code === 'gwangju') {
      return '광주광역시';
    } else if (code === 'jeonnam') {
      return '전라남도';
    } else if (code === 'gyeongbuk') {
      return '경상북도';
    } else if (code === 'daegu') {
      return '대구광역시';
    } else if (code === 'gyeongnam') {
      return '경상남도';
    } else if (code === 'ulsan') {
      return '울산광역시';
    } else if (code === 'busan') {
      return '부산광역시';
    } else if (code === 'jeju') {
      return '제주도';
    }
  }

  componentDidMount() {
    window.selected = 'none';
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      this.setState({ matches: true });
    } else {
      this.setState({ matches: false });
    }

    setTimeout(() => {
      this.deletePreMap();
      window.callMe(this.callbackFunction);
    }, 0);
    // ----- 나의 발자취 -----
    if (localStorage.getItem('loggedin') && localStorage.getItem(`${localStorage.getItem('loggedin')}_status`)) {
      this.setState({
        userInfo: localStorage.getItem('loggedin') ? JSON.parse(localStorage.getItem(`${localStorage.getItem('loggedin')}_status`)) : null,
      });
      axiosInstance
        .get(`${API_URL}/user/info?userId=${localStorage.getItem('loggedin')}`, {})
        .then((res) => {
          if (res.data && res.data.img && res.data.img !== '') {
            this.setState({ userImg: res.data.img });
          }
          if (res.data && res.data.totalCourse && res.data.totalStamp) {
            this.setState({ totalCourse: res.data.totalCourse, totalStamp: res.data.totalStamp });
          }
          this.setState({
            userStamp: res.data.stamp ? res.data.stamp.length : 0,
            userCourse: res.data.course ? res.data.course.length : 0,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.list !== prevProps.list) {
      window.selected = 'none';

      setTimeout(() => {
        this.deletePreMap();
        window.callMe(this.callbackFunction);
      }, 0);
    } else {
    }
  }

  goToPage(_move) {
    this.props.history.push(_move);
  }

  onClickLoadItem(id) {
    window.selected = 'none';
    this.props.history.push(`/mypage?course=${id}`);
  }

  onDraw() {
    if (this.canvas && this.canvas.current) {
      this.canvas.current.getContext('2d').clearRect(0, 0, 360, 400);
    }

    if (this.canvas && this.canvas.current && window.selected !== 'none' && drawData[window.selected]) {
      let color = drawData[window.selected].firstColor;

      let context = this.canvas.current.getContext('2d');

      context.imageSmoothingEnabled = false;
      context.beginPath();
      context.strokeStyle = color;
      context.lineWidth = 1;
      context.moveTo(drawData[window.selected].firstPoint[0], drawData[window.selected].firstPoint[1]);
      context.lineTo(drawData[window.selected].secondPoint[0], drawData[window.selected].secondPoint[1]);
      context.lineTo(drawData[window.selected].thirdPoint[0], drawData[window.selected].thirdPoint[1]);
      context.stroke();

      context.save();

      context.beginPath();
      context.shadowBlur = 2;
      context.shadowColor = '#555555';
      context.shadowOffsetX = 1;
      context.shadowOffsetY = 1;
      context.fillStyle = color;
      context.arc(drawData[window.selected].thirdPoint[0], drawData[window.selected].thirdPoint[1], 5, 0, 2 * Math.PI);
      context.fill();

      context.restore();

      context.beginPath();
      context.fillStyle = '#FFFFFF';
      context.arc(drawData[window.selected].thirdPoint[0], drawData[window.selected].thirdPoint[1], 2, 0, 2 * Math.PI);

      context.fill();
    }
  }

  callbackFunction = (param) => {
    this.setState({ popup: true, selectedCity: param }, () => {
      if (this.state.matches) {
        document.body.style.overflowY = 'hidden';
        if (
          navigator.userAgent.match(/mobile/i) ||
          navigator.userAgent.match(/iPhone/i) ||
          navigator.userAgent.match(/iPod/i) ||
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
        ) {
          document.body.style.overflow = 'hidden';
        }
      }
    });
  };

  deletePreMap() {
    let parent = document.getElementById('south');

    if (parent) {
      while (parent.firstChild) {
        parent.removeChild(parent.lastChild);
      }
    }
  }

  modalCloseM = () => {
    this.setState({ popup: false });

    this.deletePreMap();

    window.callMe(this.callbackFunction);
    //window.selected = 'none';
  };

  render() {
    const { classes } = this.props;

    this.onDraw();

    return this.state.matches ? (
      //모바일
      <div id="main_container" className={classes.root}>
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', flexDirection: 'column' }}>
          <div style={{ position: 'relative' }}>
            <div id="canvas" style={{ width: '300px' }}>
              <div id="south"></div>
            </div>
          </div>
        </div>

        <SelectCityDlg
          drawData={drawData}
          list={this.props.list}
          showDialog={this.state.popup}
          modalClose={this.modalCloseM}
          selected={this.state.selectedCity}
        />
      </div>
    ) : (
      // 웹
      <div id="main_container" className={classes.root}>
        <div style={{ marginTop: '10px', display: 'flex', width: '100%' }}>
          <div
            id="city_list_left"
            style={{ display: 'flex', flex: '1', flexDirection: 'column', alignItems: 'flex-end', marginBottom: '10px' }}
          >
            {drawData[window.selected] && drawData[window.selected].left === true ? (
              <div>
                <div
                  style={{
                    background: drawData[window.selected].firstColor,
                    height: '30px',
                    padding: '5px',
                    borderRadius: '15px 15px 0px 15px',
                    color: '#3E3E3E',
                    fontWeight: 900,
                    marginBottom: '5px',
                    width: '180px',
                    textAlign: 'center',
                  }}
                >
                  {this.getCodeToName(window.selected)}
                </div>
                <div
                  style={{
                    width: '180px',
                    textAlign: 'center',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    borderRadius: '15px 15px 0px 15px',
                  }}
                >
                  {this.props.list[window.selected].map((data) => {
                    return (
                      <div
                        className="city"
                        onClick={() => {
                          this.onClickLoadItem(data.id);
                        }}
                        key={'city-' + data.id}
                      >
                        {data.name}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
          <div style={{ position: 'relative' }}>
            <div id="canvas">
              <div id="south"></div>
              <div id="seoul" style={{ zIndex: 9999 }}>
                <h2>서울특별시</h2>
              </div>
              <div id="gygg" style={{ zIndex: 9999 }}>
                <h2>경기도</h2>
              </div>
              <div id="incheon" style={{ zIndex: 9999 }}>
                <h2>인천광역시</h2>
              </div>
              <div id="gangwon" style={{ zIndex: 9999 }}>
                <h2>강원도</h2>
              </div>
              <div id="chungbuk" style={{ zIndex: 9999 }}>
                <h2>충청북도</h2>
              </div>
              <div id="chungnam" style={{ zIndex: 9999 }}>
                <h2>충청남도</h2>
              </div>
              <div id="daejeon" style={{ zIndex: 9999 }}>
                <h2>대전광역시</h2>
              </div>
              <div id="sejong" style={{ zIndex: 9999 }}>
                <h2>세종특별자치시</h2>
              </div>
              <div id="gwangju" style={{ zIndex: 9999 }}>
                <h2>광주광역시</h2>
              </div>
              <div id="jeonbuk" style={{ zIndex: 9999 }}>
                <h2>전라북도</h2>
              </div>
              <div id="jeonnam" style={{ zIndex: 9999 }}>
                <h2>전라남도</h2>
              </div>
              <div id="gyeongbuk" style={{ zIndex: 9999 }}>
                <h2>경상북도</h2>
              </div>
              <div id="gyeongnam" style={{ zIndex: 9999 }}>
                <h2>경상남도</h2>
              </div>
              <div id="daegu" style={{ zIndex: 9999 }}>
                <h2>대구광역시</h2>
              </div>
              <div id="busan" style={{ zIndex: 9999 }}>
                <h2>부산광역시</h2>
              </div>
              <div id="ulsan" style={{ zIndex: 9999 }}>
                <h2>울산광역시</h2>
              </div>
              <div id="jeju" style={{ zIndex: 9999 }}>
                <h2>제주특별자치도</h2>
              </div>
            </div>

            <canvas className="canvas_draw" ref={this.canvas} width="360px" height="400px"></canvas>
          </div>
          <div
            id="city_list_right"
            style={{
              display: 'flex',
              flex: '1',
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginBottom: '10px',
            }}
          >
            {drawData[window.selected] && drawData[window.selected].left === false ? (
              <div style={{}}>
                <div
                  style={{
                    background: drawData[window.selected].firstColor,
                    height: '30px',
                    padding: '5px',
                    borderRadius: '15px 15px 0px 15px',
                    color: '#000000',
                    fontWeight: 900,
                    marginBottom: '5px',
                    width: '180px',
                    textAlign: 'center',
                  }}
                >
                  {this.getCodeToName(window.selected)}
                </div>
                <div style={{ maxHeight: '300px', overflowY: 'auto', borderRadius: '15px 15px 0px 15px' }}>
                  {this.props.list[window.selected].map((data) => {
                    return (
                      <div
                        className="cityR"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          this.onClickLoadItem(data.id);
                        }}
                        key={'city-r-' + data.key}
                      >
                        {data.name}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
          <div
            id="my_stat_grid"
            style={{
              width: '300px',
              position: 'absolute',
              left: '75vw',
            }}
          >
            <Paper
              elevation={10}
              square
              style={{
                backgroundColor: 'rgba(77, 111, 138, 0.5)',
                color: '#fff',
                borderRadius: '4px',
                overflow: 'hidden',
                // WebkitBoxShadow:
                //   'inset 1px 1px 0 rgb(255 255 255 / 20%), 0 1px 2px rgb(0 0 0 / 5%), 0px 6px 6px -3px rgb(0 0 0 / 20%), 0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%)',
                // boxShadow:
                //   'inset 1px 1px 0 rgb(255 255 255 / 20%), 0 1px 2px rgb(0 0 0 / 5%), 0px 6px 6px -3px rgb(0 0 0 / 20%), 0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%)',
              }}
            >
              <div style={{ textAlign: 'center', fontWeight: 700 }}>
                {this.state.userInfo ? (
                  <div style={{ padding: '15px 15px 0 15px' }}>
                    <Typography className={classes.userInfoText} style={{ fontWeight: 700, fontSize: '1.2em' }}>
                      나의 발자취 현황
                    </Typography>
                    <div>
                      <BsDot />
                      <BsDot />
                      <BsDot />
                    </div>
                    <Typography className={classes.userInfoText} style={{}}>
                      보유 스탬프 : {this.state.userStamp} / {this.state.totalStamp}개
                    </Typography>
                    <Typography className={classes.userInfoText} style={{ marginBottom: '0.8em' }}>
                      완주 코스 : {this.state.userCourse} / {this.state.totalCourse}
                    </Typography>
                    <div style={{ margin: '0.5em 0 1.5em ' }}>
                      <BorderLinearProgress
                        variant="determinate"
                        value={normalise(this.state.userCourse, this.state.totalCourse)}
                        color="primary"
                      />
                    </div>
                  </div>
                ) : (
                  <div style={{ padding: '15px 15px 0 15px' }}>
                    {/* <img src={'/images/foot.png'} alt={'관광벤처기업'} style={{ marginRight: '10px' }} /> */}
                    <div onClick={() => this.props.history.push('login')} className={classes.loginBtnDiv}>
                      <Typography className={classes.userInfoText} style={{}}>
                        로그인
                      </Typography>
                      <Typography className={classes.userInfoText} style={{}}>
                        (무료로 시작하기)
                      </Typography>
                    </div>
                  </div>
                )}

                <div style={{ lineHeight: '1.5em', color: '##fff', backgroundColor: 'rgba(186, 184, 184, 0.5)', padding: '15px' }}>
                  스탬프 인증대의 QR코드를 찍고 <br />
                  재미와 완주의 성취감을 누려보세요!
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(MainMap));
